var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jds-bg-grey-50 jds-min-h-screen"},[_c('div',{staticClass:"jds-w-2/3 jds-p-12"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }